import { Alert, Card, Modal } from "antd";
import styled from "styled-components";
import { color } from "../../res/color";

export const HeaderTitle = styled.div`
  margin-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 8px;

  h2 {
    margin-bottom: 8px;
  }
`;

export const StyledFormTitle = styled.h1`
  margin-bottom: 2vh;
  font-weight: lighter;
  text-decoration: underline;
`;

export const ImageIcon = styled.img`
  width: 16px;
  height: 16px;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center; /* Center content vertically */
  justify-content: flex-start; /* Move content to the left side */
`;

export const GuestCard = styled(Card)`
  border-radius: 8px;
  min-width: 400px;
  height: fit-content;
  margin-top: 50px;
  @media (max-width: 450px) {
    background: none;
    min-width: 100%;
  }
`;

export const LogoutText = styled.p`
  padding-left: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${color.LINK};
  }
`;

export const MyAlert = styled(Alert)`
  border-radius: 8px;
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 8px;
  }

  p {
    align-items: center;
  }
`;

export const MyModal = styled(Modal)`
  border-radius: 8px;
  .ant-modal-content,
  .ant-modal-header {
    border-radius: 8px;
  }

  p {
    align-items: center;
  }
  .ant-modal-title {
    font-size: 24px; /* Adjust the font size to your preference */
    border-bottom: 2px solid #888; /* Change the color to gray (#888) */
    padding-bottom: 8px; /* Adjust the padding to control the space between the title and underline */
    margin-bottom: 16px; /* Add margin at the bottom to separate it from the content */
  }
`;

export const StyledSpan = styled.span<any>`
  &.responsive-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &.details-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }

  &.detail-item {
    flex: 1;
    display: flex;
    margin-bottom: 10px;
    align-items: center;
  }

  &.item-status {
    width: 150px;
    text-align: right;
    margin-right: 10px;
  }

  &.item-value {
    flex: 1;
  }
`;
export const Box = styled.section<any>`
  padding: 24px;
  background-color: ${color.WHITE};
  border-radius: 8px;
  margin: auto;
  width: ${(p) => (p.notfull ? "700px" : "100%")};

  @media (max-width: 768px) {
    width: 100%;
    padding: 24px 16px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Head = styled.div`
  margin-bottom: 20px;
  margin-top: -20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const RightBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-end;

  @media (max-width: 600px) {
    align-items: center;
  }
`;

export const CustomHead = styled(Head)`
  align-items: center;
  @media (max-width: 600px) {
    justify-content: center;
  }
`;

export const BoxRow = styled.div`
  display: flex;
  gap: 16px;
  max-width: 1200px;
  width: 100%;
  margin: auto;

  @media (max-width: 700px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Content = styled.div`
  width: 90%;
  margin: auto;
  min-height: 100vh;
  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const FormCard = styled(Card)<any>`
  background: ${(p) => (p.nobackground ? "none" : "#ffffff")};
  .ant-card-body {
    padding: ${(p) => (p.nobackground ? "0px" : "24px")};
  }
`;
